import {
  CREATE_SUPPLIER_REQUEST,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,
  GET_ALL_SUPPLIER_REQUEST,
  GET_ALL_SUPPLIER_SUCCESS,
  GET_ALL_SUPPLIER_FAILURE,
  GET_ONE_SUPPLIER_REQUEST,
  GET_ONE_SUPPLIER_SUCCESS,
  GET_ONE_SUPPLIER_FAILURE,
  EDIT_SUPPLIER_REQUEST,
  EDIT_SUPPLIER_SUCCESS,
  EDIT_SUPPLIER_FAILURE,
  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
} from "./supplierTypes";  
 
const getAllInitialState = {
  loading: false,
  supplierList: [],
  error: "",
};

const getAllSupplierReducer = (state = getAllInitialState, action) => {
  switch (action.type) {
    case GET_ALL_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_SUPPLIER_SUCCESS:
      return {
        loading: false,
        supplierList: action.payload,
        error: "",
      };
    case GET_ALL_SUPPLIER_FAILURE:
      return {
        loading: false,
        supplierList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- GET ONE REDUCER ---
const getOneInitialState = {
  loading: false,
  supplierDetail: {},
  error: "",
};

const getOneSupplierReducer = (state = getOneInitialState, action) => {
  switch (action.type) {
    case GET_ONE_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ONE_SUPPLIER_SUCCESS:
      return {
        loading: false,
        supplierDetail: action.payload,
        error: "",
      };
    case GET_ONE_SUPPLIER_FAILURE:
      return {
        loading: false,
        supplierDetail: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- CREATE REDUCER ---
const createInitialState = {
  loading: false,
  supplierData: {},
  error: "",
};

const createSupplierReducer = (state = createInitialState, action) => {
  switch (action.type) {
    case CREATE_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_SUPPLIER_SUCCESS:
      return {
        loading: false,
        supplierData: action.payload,
        error: "",
      };
    case CREATE_SUPPLIER_FAILURE:
      return {
        loading: false,
        supplierData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- EDIT REDUCER ---
const editInitialState = {
  loading: false,
  supplierData: {},
  error: "",
};

const editSupplierReducer = (state = editInitialState, action) => {
  switch (action.type) {
    case EDIT_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_SUPPLIER_SUCCESS:
      return {
        loading: false,
        supplierData: action.payload,
        error: "",
      };
    case EDIT_SUPPLIER_FAILURE:
      return {
        loading: false,
        supplierData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- DELETE REDUCER ---
const deleteInitialState = {
  loading: false,
  successData: {},
  error: "",
};

const deleteSupplierReducer = (state = deleteInitialState, action) => {
  switch (action.type) {
    case DELETE_SUPPLIER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_SUPPLIER_SUCCESS:
      return {
        loading: false,
        successData: action.payload,
        error: "",
      };
    case DELETE_SUPPLIER_FAILURE:
      return {
        loading: false,
        successData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getAllSupplierReducer,
  getOneSupplierReducer,
  createSupplierReducer,
  editSupplierReducer,
  deleteSupplierReducer,
};